'use strict';

require('./chunk-d7703e54.js');
var variadic = require('./variadic.js');

function extend(target, objects) {
  objects.forEach(function (object) {
    Object.getOwnPropertyNames(object).forEach(function (property) {
      target[property] = object[property];
    });
  });
  return target;
}
/**
 * Creates a copy of one or more objects.
 *
 * Properties with the same key will take precedence from right to left. The
 * copy will have the *same* prototype as the *first* object in the list.
 *
 * @function
 * @param {Array} os The objects to copy.
 * @returns {Object} A copy of the objects in the list of `os`.
 * @example
 *
 * import { copy } from 'fkit'
 * const person = { name: 'Jane', age: 20, city: 'Melbourne' }
 * copy(person, { name: 'Steve' }) // { name: 'Steve', age: 20, city: 'Melbourne' }
 */


var copy = variadic(function (o, ps) {
  return extend(Object.create(Object.getPrototypeOf(o)), [o].concat(ps));
});

module.exports = copy;
